import * as React from 'react';
import { Status } from '../status/status.component';
export const StatusWrapper = ({ statusPosition, error, pending, errorIcon, validationErrorMessages, validationMode, children, }) => {
    const shouldShowErrorIcon = (!!(validationErrorMessages === null || validationErrorMessages === void 0 ? void 0 : validationErrorMessages.length) && (validationMode === 'both' || validationMode === 'icon')) || error;
    return (React.createElement(React.Fragment, null,
        statusPosition === 'left' && React.createElement(Status, { error: shouldShowErrorIcon, pending: pending, errorIcon: errorIcon, cypressTag: "status-left" }),
        children,
        statusPosition === 'right' && React.createElement(Status, { error: shouldShowErrorIcon, pending: pending, errorIcon: errorIcon, cypressTag: "status-right" })));
};
StatusWrapper.defaultProps = {
    statusPosition: 'right',
};
